import debug from 'debug';

export default debug('trimonitor:global');
export const apiLogger = debug('trimonitor:api');
